import type { TriageDeferredOptionsGateway, TriageDeferredOptionsResult } from '@core/ports/TriageDeferredOptionsGateway';

export class GetTriageDeferredOptionsUseCase {
  public constructor(private readonly triageDeferredOptionsGateway: TriageDeferredOptionsGateway) {}

  public execute(sourceListUrl: string, query?: string): Promise<TriageDeferredOptionsResult> {
    return this.triageDeferredOptionsGateway.getOptions(sourceListUrl, query);
  }
}